// extracted by mini-css-extract-plugin
export default {"toggle":"switchToggle_toggle__rr0nq","toggle--control":"switchToggle_toggle--control__w92Ia","toggle--input":"switchToggle_toggle--input__FTDpS","label":"switchToggle_label__qx-ML"};